// extracted by mini-css-extract-plugin
export default {"root":"PageAllEvents_root__bV0uU","top":"PageAllEvents_top__Lsabe"};